<template>
  <!-- space-page begin -->
  <div class="space-page">
    <div class="space-page-item space-page-body">
      <div class="w-75">
        <img class="w-100" :class="page.class" :src="page.src" alt="">
      </div>
      <i18n :path="page.wording" tag="div">
        <template v-slot:click v-if="isRedirectStatus">
          <a href="javascript:void(0)" @click="goTo()">{{ $t('global.click-here') }}</a>
        </template>
      </i18n>
    </div>
  </div>
  <!-- space-page end -->
</template>

<script>
import imgLove from '@/assets/images/img-love.svg';
import imgSmile from '@/assets/images/img-smile.svg';
import imgChat from '@/assets/images/img-chat.svg';

export default {
  props: {
    // 狀態
    status: String,
    // 導頁 url
    redirectUrl: String,
  },
  data() {
    return {
      // 頁面顯示資料
      page: {
        src: '',
        class: '',
        wording: '',
      },
    };
  },
  created() {
    const vm = this;

    // 依照狀態加入頁面顯示資料
    switch (vm.status) {
      case 'redirectOfficalAccount':
        vm.page = {
          src: imgLove,
          class: 'my-3',
          wording: 'global.please-close-window-and-back-to-offical-account',
        };
        break;
      case 'blank':
        vm.page = {
          src: imgSmile,
          class: 'my-3',
          wording: '',
        };
        break;
      default:
        vm.page = {
          src: imgChat,
          class: '',
          wording: '',
        };
        break;
    }
  },
  computed: {
    // 是否為需導頁狀態
    isRedirectStatus() {
      const list = ['redirectOfficalAccount'];
      return list.some((x) => x === this.status);
    },
  },
  methods: {
    goTo() {
      window.location.assign(this.redirectUrl);
    },
  },
};
</script>>
